import React, { useEffect, useState } from "react";
import { Button, Box, CircularProgress, FormGroup, FormControlLabel, Switch, Typography, Stack } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import userService from "../../services/userService";

const TOTPModal = (props) => {
	
	let [ totpEnabled, setTOTPEnabled ] = useState(userService.User().totpenabled);
	let [ qrcode, setQRCode ] = useState(userService.getTOTPQRCode());
	
	useEffect(() => {
		userService.getTOTPQRCode().then((qrcode) => { setQRCode(qrcode); });
	}, []);

	const handleClose = () => {
		props.onClose()
	};
	
	const handleCancel = () => {
		props.onClose()
	};

	const handleToggleEnabled = () => {
		let user = userService.User();
		user.totpenabled = user.totpenabled == 0? 1 : 0;
		userService.update(user)
		.then(() => {
			user = userService.User();
			setTOTPEnabled(user.totpenabled);

			return userService.getTOTPQRCode();
		})
		.then((qrcode) => {
			setQRCode(qrcode);
		})
		.catch((err) => {
			console.log(`Error editing user totp: ${err.message}`);
		})
		.finally(() => {
		});
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Dialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Setup Authenticator App
			</DialogTitle>
			<DialogContent>
				{ props.loading &&
					<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
						<CircularProgress sx={{ margin: "auto", textAlign: "center" }} />
					</Box>
				}
				{ !props.loading &&
					<form onSubmit={()=>{}} autoComplete="off">
						<FormGroup sx={formControlStyle}>
							<FormControlLabel
								control={
									<Switch
										checked={totpEnabled == 1}
										onChange={handleToggleEnabled}
									/>
								}
								label="Enable Authenticator App"
							/>
						</FormGroup>
					</form>
				}
				{ qrcode != null &&
					<Stack direction="column" justifyContent="center" alignItems="center">
						<Typography>
							Please use the following QR Code to add Cymplify to your authenticator app of choice
						</Typography>
						<img width="200px" height="200px" src={`${qrcode}`}/>
					</Stack>
				}
			</DialogContent>
			{ !props.loading &&
				<DialogActions>
					<Button onClick={handleCancel}>Close</Button>
				</DialogActions>
			}
		</Dialog>
	);
};

export default TOTPModal;